var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page--policies"},[_c('app-pol-nav'),_vm._v(" "),_c('section',{staticClass:"policy"},[_c('h1',{staticClass:"policy__title"},[_vm._v(" "+_vm._s(_vm.getPolicy.title)+" ")]),_vm._v(" "),_c('div',{staticClass:"policy__content",domProps:{"innerHTML":_vm._s(_vm.getPolicy.html)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e6794ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/policies/Index.vue
// module id = null
// module chunks = 